import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './StatusGmin.css';
import { Grid, Row, Col } from 'react-bootstrap';
import fetch from '../../core/fetch/fetch.server';
import waiting from './waiting-wheel-300x300.gif';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import * as _ from 'lodash';
import { fetchDistrictServices, fetchSingleDistrictServices } from '../../actions/district';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';
import { replaceMultipleSpaces } from '../../lib/utils';
import v from '../eservices/validators';
import { PanelStyle } from '../../constants';
import ModalAlert from '../eservices/ModalAlert';
import DistrictsPanel from '../../components/DistrictsPanel/DistrictsPanel';


const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;

const successMessage = 'Zmiany zostały zapisane.';
const failureMessage = 'Wystąpił błąd przy zapisie zmian.';
const errorTitle = 'Błąd przy zapisywaniu zmian.';

class StatusGmin extends React.Component {

  state = {
    selected_district: null,
    districtAdmins: [],
    editingEnabled: false,
    defaultdistrictAdmins: [],
    changedAdminsData: false,
    districtReceivers: [],
    filteredDistricts: [],
    receiversEditingEnabled: false,
    defaultdistrictReceivers: [],
    changedReceiversData: false,
    filter_text: '',
    isMounted: false,
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    errors: {},
    adminErrors: {},
    emailErrors: {},
    receiversErrors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eservicesEditingEnabled: false,
    districtEservices: [],
    defaultEservices: [],
    changedEservicesData: false,
    showEmailModal: false,
    showAdminModal: false,
    showReceiversModal: false,
    isDistrictAdmin: false,
    isLoaded: false,
  };

  validators = {
    login: [v.NotSelected],
    email: [v.NotSelected],
    emails: [v.NotNull],
    receiver: [v.NotNull],
  };


async fetchDistrictServicesWrapper() {
  try {
    let isDistrictAdmin = false;
    let prefix = null;

    const filteredDistricts = Object.values(this.props.districts)
      .filter(district => district.showOnList || district.prefix === 'gmina_giapowo')
      .sort();

    if (this.props.userData.roles.includes('districtadmin')) {
      const url = `${process.env.API_URL}/districts/district_for_user/${this.props.userData.userId}/`;
      const resp = await fetch(url);
      const r = await resp.json();
      prefix = r.district;
      isDistrictAdmin = true;
    } else {
      prefix = filteredDistricts[0].prefix;
    }

    const selected_district = await fetchSingleDistrictServices(prefix);
    if (selected_district) {
      const defaultEservices = _.cloneDeep(selected_district.services);
      const districtEservices = _.cloneDeep(selected_district.services);
      const districtReceivers = _.cloneDeep(selected_district.default_receivers);
      const defaultdistrictReceivers = _.cloneDeep(selected_district.default_receivers);

    this.setState({
      selected_district,
      districtEservices,
      defaultEservices,
      districtReceivers,
      defaultdistrictReceivers,
      isDistrictAdmin,
      filteredDistricts,
      isMounted: true,
      isLoaded: true,
    }, () => this.getUsersData());
    } else {
      this.showDistrictServicesError();
    }
  } catch (err) {
    console.error(err);
  }
}


  componentDidMount() {
    this.fetchDistrictServicesWrapper();
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  onClick = async (prefix) => {
    const selected_distr = await fetchSingleDistrictServices(prefix);
    if (selected_distr) {
      const defaultEservices = _.cloneDeep(selected_distr.services);
      const districtEservices = _.cloneDeep(selected_distr.services);
      const districtReceivers = _.cloneDeep(selected_distr.default_receivers);
      const defaultdistrictReceivers = _.cloneDeep(selected_distr.default_receivers);
      this.setState({
        selected_district: selected_distr,
        districtEservices,
        defaultEservices,
        editingEnabled: false,
        eservicesEditingEnabled: false,
        emailErrors: {},
        districtReceivers,
        defaultdistrictReceivers,
        receiversEditingEnabled: false,
        isLoaded: true,
        receiversErrors: {} }, () => this.getDistrictAdmins());
    } else {
      this.showDistrictServicesError();
    }

  };

  async getDistrictAdmins() {
    const url = `${process.env.API_URL}/districts/district_admins/${this.state.selected_district.prefix}/`;
    await fetch(url)
      .then(r => r.json())
      .then(admins => {
        this.setState({ districtAdmins: admins, defaultdistrictAdmins: admins, changedAdminsData: false });
      });
  }

  async getUsersData() {
    const url = `${process.env.API_URL}/districts/users/`;
    await fetch(url)
      .then(r => r.json())
      .then(users => {
        const logins = [];
        const emails = [];
        const usersList = [];
        for (const user of users) {
          logins.push(
            {
              state: 'login',
              value: user.login,
              label: user.login,
            }
          );
          emails.push(
            {
              state: 'email',
              value: user.email,
              label: user.email,
            }
          );
          usersList.push({
            login: user.login,
            email: user.email,
          });
        }
        this.setState({ logins, emails, usersList }, () => this.getDistrictAdmins());
      });
  }

  districtFilterChange = (e) => {
    //zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ filter_text: value });
  };

  getInputWithError = (group, field, idx, value, placeholder, editingState, errorsState, changedState, callback) => (
    <div style={{ textAlign: 'justify' }}>
      <input
        type="text"
        className="form-control"
        key={`input_${field}${idx}`}
        name={`input_${field}${idx}`}
        autoComplete='none'
        style={this.errorStyle(errorsState, `${field}${idx}`)}
        value={value ? value : ''}
        placeholder={placeholder}
        disabled={!this.state[editingState]}
        onChange={e => this.onChange(e, group, field, idx, changedState, callback, errorsState)}
      />
      {this.renderErrorsInSpan(errorsState, `${field}${idx}`)}
    </div>
  )

  errorStyle = (errorsState, errorField) => (
    {
      width: '100%',
      borderColor:
        Object.keys(this.state[errorsState]).indexOf(errorField) > -1 &&
          this.state[errorsState][errorField] !== null &&
          this.state[errorsState][errorField].length > 0
          ? 'red'
          : '#ccc',
    }
  )

  renderErrorsInSpan = (errorsState, errorField) => {
    return (    
      <div>
      {Object.keys(this.state[errorsState]).indexOf(errorField) > -1 &&
      this.state[errorsState][errorField] !== null &&
      this.state[errorsState][errorField].length > 0
      ? this.state[errorsState][errorField].map((val) => (
        <span key={val} style={errorSpanStyle}>
          {val}
        </span>
      ))
      : null}
    </div>)
    }
    

  onChange = (e, group, elem, idx, changedState, callback, errorField) => {
    const arr = this.state[group];
    arr[idx][elem] = e.target.value;
    this.setState({
      [group]: arr,
      [changedState]: true,
    }, () => callback(errorField, group, elem, idx),
    );
  };

  getSelectWithError = (group, field, idx, value, options) => (
    <div style={{ textAlign: 'justify' }}>
      <Select
        noResultsText={'brak wyników'}
        clearable={false}
        options={options}
        value={value}
        placeholder={'Wybierz z listy...'}
        disabled={!this.state.editingEnabled}
        onChange={e => this.onChangeAdminSelect(e, group, field, idx)}
        style={this.errorStyle('adminErrors', `${field}${idx}`)}
        onBlur={event => event.preventDefault()}
        optionClassName="needsclick"
        blurInputOnSelect={false}
      />
      {this.renderErrorsInSpan('adminErrors', `${field}${idx}`)}
    </div>
  )

  onChangeAdminSelect = (e, state, elem, index) => {
    const arr = this.state[state];
    const defaultdistrictAdmins = _.cloneDeep(this.state.defaultdistrictAdmins);
    if (elem === 'login') {
      for (const user of this.state.usersList) {
        if (user.login === e.value) {
          arr[index].email = user.email;
        }
      }
    }

    if (elem === 'email') {
      for (const user of this.state.usersList) {
        if (user.email === e.value) {
          arr[index].login = user.login;
        }
      }
    }
    arr[index][elem] = e.value;

    this.setState({
      [state]: arr,
      defaultdistrictAdmins,
      changedAdminsData: true,
    }, () => this.validate('adminErrors', state));
  };

  getIndexedInputWithError = (group, field, idx, subidx, value, placeholder) => (
    <tr key={`tr_${field}_${idx}_${subidx}`}>
      <td>
        {this.state.eservicesEditingEnabled ? 
        <button
          type="submit-lg"
          className='btn btn-danger'
          onClick={() => this.removeEmail(idx, subidx)}
          disabled={!this.state.eservicesEditingEnabled}
        >
          X
        </button> : null}
      </td>
      <td>
      <input
        autoComplete='none'
        key={`indexedinput_${field}_${idx}_${subidx}`}
        type="text"
        className="form-control"
        name={`indexedinput_${field}_${idx}_${subidx}`}
        style={this.errorStyle('emailErrors', `${idx}${field}${subidx}`)}
        value={value}
        placeholder={placeholder}
        disabled={!this.state.eservicesEditingEnabled}
        onChange={(e) => this.onChangeEmail(e, group, field, idx, subidx)}
      />
      </td>
    </tr>
  )

  addPosition = () => {
    this.setState({
      districtAdmins: [...this.state.districtAdmins, {
        login: '',
        email: '',
      }],
      changedAdminsData: true,
    }, () => this.validate('adminErrors', 'districtAdmins'));
  }

  addReceiver = () => {
    this.setState({
      districtReceivers: [...this.state.districtReceivers, {
        receiver: '',
      }],
      changedReceiversData: true,
    }, () => this.validate('receiversErrors', 'districtReceivers'));
  }

  addEmail = (idx) => {
    const districtEservices = _.cloneDeep(this.state.districtEservices);
    districtEservices[idx].emails = [...districtEservices[idx].emails, ''];
    this.setState({
      districtEservices,
      changedEservicesData: true,
    }, () => this.validate('emailErrors', 'districtEservices'));
  }

  removeEmail = (idx, subidx) => {
    const {districtEservices} = this.state;

    if (subidx > -1) {
      districtEservices[idx].emails.splice(subidx, 1);
    }

    this.setState({
      districtEservices,
      changedEservicesData: true,
    }, () => this.validate('emailErrors', 'districtEservices'));
  }

  onChangeEmail = (e, state, elem, index, subidx) => {
    const arr = this.state[state];
    arr[index][elem][subidx] = e.target.value;

    this.setState({
      [state]: arr,
      changedEservicesData: true,
    }, () => this.validate('emailErrors', state, elem, index, subidx),
    );
  }

  removePosition = (i, state, changedState, errorField, callback) => {
    const list = [...this.state[state]];

    if (i > -1) {
      list.splice(i, 1);
    }

    this.setState({
      [state]: list,
      [changedState]: true,
      }, () => callback(errorField, state)
    );
  }

  validate = (errorField, group = null, field = null, index = null, subidx = null) => {
    let newState = null;
    if (field) {
      const checks = this.validateField(group, field, index, subidx);
      if (subidx !== null) {
        newState = {
          ...this.state[errorField],
          [`${index}${field}${subidx}`]: checks,
        };
      } else {
        newState = {
          ...this.state[errorField],
          [`${field}${index}`]: checks,
        };
      }

    } else {
      if (group) {
        let errors = {};
        const err = this.validateGroup(group);
        errors = { ...errors, ...err };
        newState = { ...errors };
      }
    }

    if (newState) {
      this.setState({ [errorField]: newState });
    }
  };

  validateGroup = (group) => {
    const errors = {};
    let idx = 0;
    if (this.state[group]) {
      for (const obj of this.state[group]) {
        for (const i in Object.keys(obj)) {
          const field = Object.keys(obj)[i];
          if (group === 'districtEservices' && field === 'emails') {
            let subidx = 0;
            for (const value of this.state[group][idx][field]) {
              const checks = this.validateField(group, field, idx, subidx);
              errors[`${idx}${field}${subidx}`] = checks;
              subidx += 1;
            }
          }
          else {
            const checks = this.validateField(group, field, idx);
            errors[`${field}${idx}`] = checks;
          }
        }
        idx += 1;
      }
    }
    return errors;
  };

  validateField = (group, field, index, subidx = null) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        let check = null;
        if (subidx !== null) {
          check = validator(this.state[group][index][field][subidx]);
        } else {
          check = validator(this.state[group][index][field]);
        }
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  startEditing = (state) => {
    this.setState({ [state]: true });
  }

  onHide = () => this.setState({ showError: false });

  cancelAdminsEdition = () => {
    const data = _.cloneDeep(this.state.defaultdistrictAdmins);
    this.setState({ districtAdmins: data, changedAdminsData: false, editingEnabled: false }, () => this.validate('adminErrors','districtAdmins'));
  }

  cancelReceiversEdition = () => {
    const data = _.cloneDeep(this.state.defaultdistrictReceivers);
    this.setState({ districtReceivers: data, changedReceiversData: false, receiversEditingEnabled: false }, () => this.validate('receiversErrors', 'districtReceivers'));
  }

  cancelEservicesEdition = () => {
    const data = _.cloneDeep(this.state.defaultEservices);
    this.setState({ districtEservices: data, changedEservicesData: false, eservicesEditingEnabled: false, emailErrors: {} }, () => this.validate('emailErrors', 'districtEservices'));
  }

  haseErrors = (errorField) => {
    for (const key of Object.keys(this.state[errorField])) {
      if (this.state[errorField][key].length > 0) return true;
    }
    return false;
  };

  showModalAlert = () => {
    const hasFieldErrors = this.checkErrors('adminErrors');

    if (!hasFieldErrors) {
      this.setState({
        showAdminModal: !this.state.showAdminModal,
      });
    }
  }

  showReceiversModalAlert = () => {
    const hasFieldErrors = this.checkErrors('receiversErrors');

    if (!hasFieldErrors) {
      this.setState({
        showReceiversModal: !this.state.showReceiversModal,
      });
    }
  }

  showEmailsModalAlert = () => {
    const hasFieldErrors = this.checkErrors('emailErrors');

    if (!hasFieldErrors) {
      this.setState({
        showEmailModal: !this.state.showEmailModal,
      });
    }
  }

  showDistrictServicesError = () => {
    return this.setState({
      errorText: 'Wystąpił nieoczekiwany błąd podczas pobierania danych.',
      errorTitle: 'Błąd pobierania danych.',
      showError: true,
      isMounted: true,
    });
  }

  checkErrors = (errorField) => {
    const hasFieldErrors = this.haseErrors(errorField);

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return true;
    }

    return false;
  }

  updateAdmins = () => {
    const data = JSON.stringify(this.state.districtAdmins);
    fetch(`${process.env.API_URL}/districts/district_admins/save/${this.state.selected_district.prefix}/`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: data,
    },
  ).then((response) => {
      if (response.status === 200) {
        const defaultdistrictAdmins = _.cloneDeep(this.state.districtAdmins);
        this.setState({
          errorText: successMessage,
          errorTitle: 'Zmiany zapisane.',
          showError: true,
          showAdminModal: false,
          defaultdistrictAdmins,
          editingEnabled: false,
          changedAdminsData: false,
        });
      } else {
        this.setState({
          errorText: failureMessage,
          errorTitle,
          showError: true,
          showAdminModal: false,
        });
      }
    })
    .catch((err) => {
      console.error(err);
      this.setState({
        errorText: failureMessage,
        errorTitle,
        showError: true,
        showAdminModal: false,
      });
    });
  }

  updateReceivers = () => {
    const data = JSON.stringify(this.state.districtReceivers);
    fetch(`${process.env.API_URL}/districts/district_receivers/save/${this.state.selected_district.prefix}/`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: data,
    },
  ).then((response) => {
      if (response.status === 200) {
        const defaultdistrictReceivers = _.cloneDeep(this.state.districtReceivers);
        this.setState({
          errorText: successMessage,
          errorTitle: 'Zmiany zapisane.',
          showError: true,
          showReceiversModal: false,
          defaultdistrictReceivers,
          receiversEditingEnabled: false,
          changedReceiversData: false,
        });
      } else {
        this.setState({
          errorText: failureMessage,
          errorTitle,
          showError: true,
          showReceiversModal: false,
        });
      }
    })
    .catch((err) => {
      console.error(err);
      this.setState({
        errorText: failureMessage,
        errorTitle,
        showError: true,
        showReceiversModal: false,
      });
    });
  }

  updateEmails = () => {
    const data = JSON.stringify(this.state.districtEservices);
    fetch(`${process.env.API_URL}/districts/district_services/save/${this.state.selected_district.prefix}/`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: data,
    },
  ).then((response) => {
      if (response.status === 200) {
        const defaultEservices = _.cloneDeep(this.state.districtEservices);
        this.setState({
          errorText: successMessage,
          errorTitle: 'Zmiany zapisane.',
          showError: true,
          showEmailModal: false,
          defaultEservices,
          eservicesEditingEnabled: false,
          changedEservicesData: false,
        });
      } else {
        this.setState({
          errorText: failureMessage,
          errorTitle,
          showError: true,
          showEmailModal: false,
        });
      }
    })
    .catch((err) => {
      console.error(err);
      this.setState({
        errorText: failureMessage,
        errorTitle,
        showError: true,
        showEmailModal: false,
      });
    });
  }

  // modal z potwierdzeniem lub odrzuceniem zmian
  savingChangesModal = (messageType, showModalMethod, confirmMethod) => {
    const messages = {
      1: 'Czy na pewno chcesz zapisać zmiany?',
      2: 'Czy na pewno chcesz zapisać zmiany? Zmiana adresu skrytki ePUAP może spowodawać błędy w działaniu powiązanych usług typu EOD.',
    }
    return (
      <div className={s.modal}>
        <div className={s.modal__container} style={{...this.state.style, height: '200px' }}>
          <div className={s.modal__header}>{messages[messageType]}</div>
          <div className={s.usrButtons}>
            <button onClick={showModalMethod} className="btn btn-warning">Anuluj</button>
            <button onClick={confirmMethod} className={`btn btn-success ${s.usrButtons__right}`}>Zapisz</button>
          </div>
        </div>
      </div>
    );
  }

  renderReceiversView = () => {
    return (
      <div style={this.state.style}>
        <Row>
          <br />
          <Col className="rwd-class" xs={12}>
            <h5 style={{ textAlign: 'left' }}>
              <b>Domyślne adresy e-mail do powiadomień:</b>
            </h5>
            <h5 style={{ textAlign: 'left' }}>
              Jeżeli dana usługa nie ma przypisanego adresu e-mail to powiadomienia będą trafiały na adresy domyślne.
            </h5>
          </Col>
        </Row>
        <Row>
          <Col className="rwd-class" xs={12}>
            {!this.state.receiversEditingEnabled ?
            <button
              type="submit-lg"
              className='btn btn-warning'
              onClick={() => this.startEditing('receiversEditingEnabled')}
            >
              Edytuj
            </button> : null}
            {this.state.receiversEditingEnabled ? 
              <button
                type="submit-lg"
                className='btn btn-default'
                onClick={() => this.addReceiver()}
              >
                Dodaj
              </button>
            : null}
            {this.state.changedReceiversData ? 
              <button
                type="submit-lg"
                className='btn btn-success'
                onClick={() => this.showReceiversModalAlert()}
              >
                Zapisz
              </button>
            : null}
            {this.state.receiversEditingEnabled ? 
              <button
                type="submit-lg"
                className='btn btn-danger'
                onClick={() => this.cancelReceiversEdition()}
              >
                Anuluj
              </button>
            : null}
          </Col>
        </Row>
        <Row>
          <Col className="rwd-class" xs={12}>
            {this.state.districtReceivers.length > 0 ?
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">LP</th>
                    <th scope="col">Email</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.districtReceivers.map((v, i) => {
                    return (
                      <tr key={v.id}>
                        <td>{i + 1}</td>
                        <td>
                          {this.getInputWithError('districtReceivers', 'receiver', i, v.receiver, 'e-mail...', 'receiversEditingEnabled', 'receiversErrors', 'changedReceiversData', this.validate)}

                        </td>
                        <td>
                          <button
                            type="submit-lg"
                            className='btn btn-danger'
                            onClick={() => this.removePosition(i, 'districtReceivers', 'changedReceiversData', 'receiversErrors', this.validate)}
                            disabled={!this.state.receiversEditingEnabled}
                          >
                            Usuń
                          </button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table> : 
              <p style={{ textAlign: 'center' }}>Lista domyślnych adresów e-mail jest pusta</p>}
          </Col>
        </Row>
      </div>
    );
  };

  renderButtons = () => (
    <div>
      <button
        type="submit-lg"
        className='btn btn-success'
        onClick={() => this.showModalAlert()}
      >
        Zapisz
      </button>
    </div>
  )

  renderAdminsView = () => {
    return (
      <div style={this.state.style}>
        <Row>
          <br />
          <Col className="rwd-class" xs={12}>
            <h5 style={{ textAlign: 'left' }}>
              <b>Lista adminów gminnych:</b>
            </h5>
          </Col>
        </Row>
        <Row>
          <Col xs={12} style={{ display: 'flex' }}>
            {!this.state.editingEnabled ?
            <button
              type="submit-lg"
              className='btn btn-warning'
              onClick={() => this.startEditing('editingEnabled')}
            >
              Edytuj
            </button> : null }
            {this.state.editingEnabled ? 
              <button
                type="submit-lg"
                className='btn btn-default'
                onClick={() => this.addPosition()}
              >
                Dodaj
              </button>
            : null}
            {this.state.changedAdminsData ? this.renderButtons() : null}
            {this.state.editingEnabled? 
              <button
                type="submit-lg"
                className='btn btn-danger'
                onClick={() => this.cancelAdminsEdition()}
              >
              Anuluj
              </button> : null}
          </Col>
        </Row>
        <Row>
          <Col className="rwd-class" xs={12}>
            {this.state.districtAdmins.length > 0 ?
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">LP</th>
                    <th scope="col">Login</th>
                    <th scope="col">Email</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.districtAdmins.map((v, i) => {
                    return (
                      <tr key={Math.random()}>
                        <td>{i + 1}</td>
                        <td>
                          {this.getSelectWithError('districtAdmins', 'login', i, v.login, this.state.logins)}
                        </td>
                        <td>
                          {this.getSelectWithError('districtAdmins', 'email', i, v.email, this.state.emails)}
                        </td>
                        <td>
                          <button
                            type="submit-lg"
                            className='btn btn-danger'
                            onClick={() => this.removePosition(i, 'districtAdmins', 'changedAdminsData', 'adminErrors', this.validate)}
                            disabled={!this.state.editingEnabled}
                          >
                            Usuń
                          </button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table> : 
              <p style={{ textAlign: 'center' }}>Lista adminów jest pusta</p>}
          </Col>
        </Row>
      </div>
    );
  };

  renderView = () => {
    return (
      <div className={s.sgContainer} style={this.state.style}>
        <Grid style={{ width: '100%' }}>
          <Row>
            { !this.state.isDistrictAdmin ?
              <Col xs={3}>
                <DistrictsPanel
                  districts={this.state.filteredDistricts}
                  onClick={this.onClick}
                />
              </Col>
            : null }

            {this.state.isLoaded ? 
            <Col xs={!this.state.isDistrictAdmin ? 9 : 12}>
              <Row>
                {this.state.selected_district ? <h4 style={{ textAlign: 'left' }}>
                  <b>{this.state.selected_district.name}:<br></br><br></br></b>
                </h4> : null}
              </Row>
              <Row>
                <table style={{ width: '100%' }}>
                  <tr>
                    <th style={{ width: '10%', textAlign: 'center' }}>Certyfikat PZ:</th>
                    <th style={{ width: '15%', textAlign: 'center' }}>
                      {this.state.selected_district.isCert ?
                        <input type="text" disabled className='form-control' style={{ color: 'green', textAlign: 'center' }} value='TAK' /> :
                        <input type="text" disabled className='form-control' style={{ color: 'red', textAlign: 'center' }} value='NIE' />}
                    </th>
                    <th style={{ width: '10%', textAlign: 'center' }}>Data ważności:</th>
                    <th style={{ width: '30%', textAlign: 'center' }}>
                      <input type="text" disabled className='form-control' style={{ textAlign: 'center' }} value={this.state.selected_district.certDate} />
                    </th>
                    <th style={{ width: '35%', textAlign: 'center' }} />
                  </tr>
                </table>
              </Row>
              <Row>
                <table style={{ width: '100%' }}>
                  <tr>
                    <th style={{ width: '10%', textAlign: 'center' }}>Certyfikat WK:</th>
                    <th style={{ width: '15%', textAlign: 'center' }}>
                      {this.state.selected_district.isWkCert ?
                        <input type="text" disabled className='form-control' style={{ color: 'green', textAlign: 'center' }} value='TAK' /> :
                        <input type="text" disabled className='form-control' style={{ color: 'red', textAlign: 'center' }} value='NIE' />}
                    </th>
                    <th style={{ width: '10%', textAlign: 'center' }}>Data ważności:</th>
                    <th style={{ width: '30%', textAlign: 'center' }}>
                      <input type="text" disabled className='form-control' style={{ textAlign: 'center' }} value={this.state.selected_district.wkCertDate} />
                    </th>
                    <th style={{ width: '35%', textAlign: 'center' }} />
                  </tr>
                </table>
              </Row>
              <Row>
                <table style={{ width: '100%' }}>
                  <tr>
                    <th style={{ width: '10%', textAlign: 'center' }}>Płatności:</th>
                    <th style={{ width: '15%', textAlign: 'center' }}>
                      {this.state.selected_district.payment_methods.length ?
                        <input type="text" disabled className='form-control' style={{ color: 'green', textAlign: 'center' }} value='TAK' /> :
                        <input type="text" disabled className='form-control' style={{ color: 'red', textAlign: 'center' }} value='NIE' />}
                    </th>
                    <th style={{ width: '10%', textAlign: 'center' }}>Nr konta:</th>
                    <th style={{ width: '30%', textAlign: 'center' }}>
                      {this.state.selected_district.bankAccounts.map((account, i) => {
                        return (
                          <input key={`bankAccounts${i}`} type="text" disabled className='form-control' style={{ textAlign: 'center' }} value={account} />
                        );
                      })}
                    </th>
                    <th style={{ width: '10%', textAlign: 'center' }}>Rodzaj:</th>
                    <th style={{ width: '25%', textAlign: 'center' }}>
                      <input type="text" disabled className='form-control' style={{ textAlign: 'center' }} value={this.state.selected_district.payment_methods.join('/')} />
                    </th>
                  </tr>
                </table>
              
              </Row>
              {this.state.selected_district && this.state.selected_district.questionnaireEnabled ?
                <Row style={{ marginTop: '20px' }}>
                  <Col className="rwd-class" xs={3} style={{ paddingLeft: '0px' }}>
                    <h5 style={{ textAlign: 'left' }}>
                      <b>Ankieta satysfakcji interesanta:</b>
                    </h5>
                  </Col>
                  <Col className="rwd-class" xs={8} style={{ paddingLeft: '0px' }}>
                    <a
                      className='btn btn-success'
                      href={`${process.env.API_URL}/eservices/${this.state.selected_district.prefix}/questionnaire_report/${this.props.userData.userId}/`}
                    >
                      Pobierz raport
                    </a>
                  </Col>
                </Row>
              : null}
              {!this.state.isDistrictAdmin ?
              <Row>
                {this.renderAdminsView()}
              </Row>
              : null}
              
              {this.renderReceiversView()}
              <Row>
                <Col className="rwd-class" xs={2}>
                  <h5 style={{ textAlign: 'left' }}>
                    <b>Lista usług:</b>
                  </h5>
                </Col>
              </Row>
              <Row>
                <Col className="rwd-class" xs={12}>
                  {!this.state.eservicesEditingEnabled ? 
                  <button
                    type="submit-lg"
                    className='btn btn-warning'
                    onClick={() => this.startEditing('eservicesEditingEnabled')}
                  >
                    Edytuj
                  </button> : null}
                  {this.state.changedEservicesData ? 
                    <button
                      type="submit-lg"
                      className='btn btn-success'
                      onClick={() => this.showEmailsModalAlert()}
                    >
                      Zapisz
                    </button>
                  : null}
                  {this.state.eservicesEditingEnabled ? 
                    <button
                      type="submit-lg"
                      className='btn btn-danger'
                      onClick={() => this.cancelEservicesEdition()}
                    >
                      Anuluj
                    </button>
                  : null}
                </Col>
                
              </Row>  
              <Row>
                <Col className="rwd-class" xs={12}>
                  <table className='table'>
                    <thead className='thead-light'>
                      <tr>
                        <th style={{ width: '50%', textAlign: 'center' }}><b>Nazwa usługi:</b></th>
                        <th style={{ width: '25%', textAlign: 'center' }}><b>Adresy e-mail:</b></th>
                        <th style={{ width: '25%', textAlign: 'center' }}><b>Skrytka ePUAP:</b></th>
                      </tr>
                    </thead>
                  </table>
                  {this.state.selected_district ?
                    <ul className='nav flex-column' style={{ height: '550px', overflowY: 'auto', width: '100%' }}>
                      {this.state.districtEservices.map((service, idx) => {
                        return (
                          <li className='nav-item' key={`service_${idx}`}>

                            <table style={{ width: '100%' }}>
                              <tr>
                                <td style={{ width: '50%', textAlign: 'justify', padding: '0px 5px' }}>
                                  {service.title}
                                  {this.state.eservicesEditingEnabled ? 
                                    <button
                                      type="submit-lg"
                                      className='btn btn-default'
                                      onClick={() => this.addEmail(idx)}
                                    >
                                      Dodaj
                                    </button>
                                  : null}  
                                </td>
                                <td style={{ width: '25%', textAlign: 'center', padding: '0px 5px' }}>
                                  {service.emails.length > 0 ?
                                  <table>
                                    {service.emails.map((email, i) => {
                                      return (
                                        <table>
                                        <tr>{this.getIndexedInputWithError('districtEservices', 'emails', idx, i, this.state.districtEservices[idx].emails[i], 'e-mail...')}</tr>
                                        <tr>{this.renderErrorsInSpan('emailErrors', `${idx}emails${i}`)}</tr>
                                        </table> 
                                        );
                                    })}
                                    </table> :
                                    <p>brak</p>
                                    }
                                </td>
                                <td style={{ width: '25%', textAlign: 'center', padding: '0px 5px' }}>
                                  {this.getInputWithError('districtEservices', 'skrytkaEPUAP', idx, this.state.districtEservices[idx].skrytkaEPUAP, 'skrytka ePUAP...', 'eservicesEditingEnabled', 'emailErrors', 'changedEservicesData', this.validate)}
                                </td>
                              </tr>
                            </table>
                            <hr style={{ marginTop: '2px', marginBottom: '2px' }}></hr>
                          </li>
                        );
                      })}
                    </ul> : null}
                </Col>
              </Row>
            </Col> :
             <Col xs={!this.state.isDistrictAdmin ? 9 : 12}>
              <GrayPanel
                title="Trwa ładowanie zawartości..."
                bodyStyle={{ textAlign: 'center', marginTop: '100px', marginBottom: '100px' }}
              >
                <img alt="Loader" src={waiting} />
              </GrayPanel>
             </Col>
            }
          </Row>
        </Grid>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        {this.state.showAdminModal ? this.savingChangesModal(1, this.showModalAlert, this.updateAdmins) : null}
        {this.state.showReceiversModal ? this.savingChangesModal(1, this.showReceiversModalAlert, this.updateReceivers) : null}
        {this.state.showEmailModal ? this.savingChangesModal(2, this.showEmailsModalAlert, this.updateEmails) : null}
      </div>
    );
  }

  render() {
    return (this.state.isMounted ? this.renderView() : (
      <GrayPanel
        title="Trwa ładowanie zawartości..."
        bodyStyle={{ textAlign: 'center', marginTop: '100px', marginBottom: '100px' }}
      >
        <img alt="Loader" src={waiting} />
      </GrayPanel>))

  }
}

const mapState = state => ({

  username: state.user ? state.user.username : '',
  districts: state.district.districts,
  all_eservices: state.district.districtServicesData
});

const mapDispatch = {
  fetchDistrictServices,
};

export default withStyles(s)(connect(mapState, mapDispatch)(StatusGmin));



// WEBPACK FOOTER //
// src/routes/StatusGmin/StatusGmin.jsx